import { Text, View } from '@react-pdf/renderer';

import { styles } from '../style';

interface Props {
  homeinspectionNegotiationDays?: number;
}

const SewerInspection = ({ homeinspectionNegotiationDays }: Props) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Sewer Inspection Contingency Clause</Text>
      <View style={styles.list}>
        <Text style={styles.listItem}>
          1) This contract is contingent upon the Buyer obtaining, at their own
          expense, a professional Sewer inspection of the Property within{' '}
          <Text style={styles.bold}>{homeinspectionNegotiationDays}</Text> days
          from the date of contract execution. The inspection shall assess the
          condition and functionality of the property's Sewer system.
        </Text>
        <Text style={styles.listItem}>
          2) Should the inspection reveal any material defects, obstructions, or
          deficiencies in the Sewer system, the Buyer shall have the right to:
        </Text>
        <View style={styles.subList}>
          <Text style={styles.listItem}>
            a) Request Repairs or Remedies: Notify the Seller, in writing,
            within the inspection period of {homeinspectionNegotiationDays} days
            after the execution date, detailing the specific repairs or remedies
            required. The Seller shall respond and agree to the requested
            repairs or provide an alternative resolution acceptable to the Buyer
            within the inspection period.
          </Text>
          <Text style={styles.listItem}>
            b) Terminate the Contract: If the Seller fails to agree to or
            complete the requested repairs or if an acceptable resolution is not
            reached within the specified or agreed to time frame, the Buyer may,
            at their sole discretion, terminate this contract by providing
            written notice to the Seller. Upon such termination, all deposits
            made by the Buyer shall be promptly refunded in full, and neither
            party shall have any further obligations under this contract.
          </Text>
        </View>
        <Text style={styles.listItem}>
          3) Access to the Property for the purpose of conducting the Sewer
          inspection shall be provided by the Seller with reasonable notice to
          the Seller's Agent. If the Buyer chooses to conduct additional home
          inspections beyond the Sewer inspection, those shall also be conducted
          at the Buyer's expense, with similar access provisions.
        </Text>
        <Text style={styles.listItem}>
          <strong>4.</strong> This contingency shall be deemed satisfied or
          waived if the Buyer does not deliver written notice to the Seller
          regarding the inspection results and any required actions within the
          specified time frames.
        </Text>
      </View>
    </View>
  );
};

export default SewerInspection;
